import React from 'react';
import { useParams } from 'react-router-dom';
import LessonTemplate from '../components/LessonTemplate';

export default function LessonDetail() {
  const { moduleId, courseId, lessonId } = useParams();
  return <LessonTemplate moduleId={moduleId} courseId={courseId} lessonId={lessonId} />;
}
